import { regions } from "@/components/staticFiles/stateLookup.js"
import { listStates } from "@/components/staticFiles/stateLookup.js"
import { listmonths } from '@/components/staticFiles/months.js'

// header background image
export function getbkUrl(month,state) {

    // Look up state -> abbreviation, falling back to CA when:
    //   - state is the placeholder "Select a State"
    //   - state is the transient "Use My Location" (set by v-model before
    //     the async geolocation handler resolves the real state)
    //   - state is missing or otherwise not present in listStates
    let stateMatch = (state && state != 'Select a State' && state != 'Use My Location')
        ? listStates.find( ({ desc }) => desc == state )
        : null
    let stateval = stateMatch ? stateMatch.value : 'CA'

    // Same defensive lookup for month -- "Current Month Selection" is a
    // transient label that isn't in listmonths.
    let monthMatch = (month && month != 'Any Month' && month != 'Current Month Selection')
        ? listmonths.find( ({ desc }) => desc == month )
        : null
    let monthval = monthMatch ? monthMatch.value : 9

    let imagepath = require.context('@/assets/img/bg/', false, /\.jpg$/)
    let dimension = ['-544x667.jpg','-768x550.jpg','-992x550.jpg','-1200x550.jpg','-1920x550.jpg']
    let region =  (!stateMatch) ? "southeast" : regions[stateval]
    let season = (!monthMatch) ? 'summer' : (monthval <= 4 || monthval == 23 || monthval == 24) ? "winter" : (monthval >= 5 && monthval <= 10) ? "spring" : (monthval >= 11 && monthval <= 16) ? "summer" : "fall"
    // let season = (monthval <= 4 || monthval == 23 || monthval == 24) ? "winter" : (monthval >= 5 && monthval <= 10) ? "spring" : (monthval >= 11 && monthval <= 16) ? "summer" : "fall"
    return imagepath('./' + region + '-' + season + dimension[4])
}

export function getImgUrl(veg) {
    // let dimension = "-350x184.jpg";
    // dimension = isMobile ? "-350x184.jpg" : "-190x100.jpg";
    let imagepath = require.context('@/assets/img/veg/', false, /\.jpg$/)
    return imagepath('./' + veg + "-350x184.jpg")
}

export function toURL(veg) {
    if (!veg || veg.length == 0 || veg == 'Select a State') {
        return 'southern-california'
    } else if (!veg || veg.length == 0 || veg == 'Any Month') {
        return 'early-may'
    } else {
        return veg.toString().replace(/ /g,"-").toLowerCase()
    }
}

export function toURLm(veg) {
    if (!veg || veg.length == 0 || veg == 'Any Month') {
        return 'early-may'
    } else {
        return veg.toString().replace(/ /g,"-").toLowerCase()
    }
}

export function toURLreverse (veg) {
    if (veg && veg != 'washington-dc') {
        return veg.replace(/-/g," ").replace(/\w\S*/g, function(txt){return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();})
    } else if (veg == 'washington-dc') {
        return 'Washington DC'
    }
}